import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { TRANSLATION_NS } from '@contact/upgrade';

import { EngagementStoreModule } from './store/engagement-store.module';

@NgModule({
  imports: [EngagementStoreModule],
})
export class EngagementCoreForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: EngagementCoreForRootModule) {
    if (parentModule) throw new Error(`[EngagementCoreForRootModule] module is already loaded`);
  }

  static instance(): ModuleWithProviders<EngagementCoreForRootModule> {
    return {
      ngModule: EngagementCoreForRootModule,
      providers: [
        {
          provide: TRANSLATION_NS,
          useValue: 'engagement',
          multi: true,
        },
      ],
    };
  }
}
